<template>
  <div>
    <form @submit="loginJWT" v-show="!email_security_active">
      <vs-input
        v-validate="'required|email|min:3'"
        data-vv-validate-on="blur"
        name="email"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Email"
        v-model="email"
        autofocus
        class="w-full"
      />
      <span class="text-danger text-sm">{{ errors.first('email') }}</span>

      <vs-input
        data-vv-validate-on="blur"
        v-validate="'required|min:6'"
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Password"
        v-model="password"
        class="w-full mt-6"
      />
      <span class="text-danger text-sm">{{ errors.first('password') }}</span>

      <div class="flex flex-wrap justify-between my-5 mb-3">
        <vs-button button="submit" :disabled="!validateForm">Login</vs-button>
      </div>
    </form>

    <form action @submit="emailSecuritySubmit" v-show="email_security_active" class="mb-10">
      <div class="p-8">
        <div class="vx-card__title mb-8">
          <h4 class="mb-4">Verificação de Segurança</h4>
          <p>Digite o código enviado ao seu e-mail.</p>
        </div>
        <vs-input
          name="emailsecuritycode"
          icon="icon icon-lock"
          icon-pack="feather"
          label-placeholder="Digite aqui o código"
          v-model.trim="email_security_code"
          autocomplete="off"
          class="w-full no-icon-border mb-5"
        />

        <vs-button color="danger" class="float-left" @click="emailSecurityCancel">Voltar ao Login</vs-button>
        <vs-button class="float-right" @click="emailSecurityCheck">Continuar</vs-button>
        <button type="submit" style="display: none"></button>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';

export default {
  data() {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      email_security_code: '',
      email_security_active: false,
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email !== '' && this.password !== '';
    }
  },
  methods: {
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        });

        return false;
      }
      return true;
    },
    loginJWT(e) {
      e.preventDefault();

      this.$vs.loading();

      const payload = {
        email: this.email,
        password: this.password,
        email_security_device_fingerprint: localStorage.getItem('emailSecurityDeviceFingerprint') || null,
      };

      axios
        .post('/api/v1/backend/auth/login', payload)
        .then(response => {
          if (response.data.access_token) {
            localStorage.setItem('user', JSON.stringify(response.data));

            Vue.prototype.$api = axios.create({
              headers: {
                Authorization: `Bearer ${response.data.access_token}`
              }
            });

            this.$router.push('/').catch(() => {
            });
          } else {
            this.$vs.loading.close();
            this.email_security_active = true;
          }
        })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    },

    emailSecurityCheck() {
      this.$vs.loading();

      this.$api
      .post('/api/v1/backend/auth/login', {
        email: this.email,
        password: this.password,
        email_security_code: this.email_security_code
      })
      .then((response) => {
        localStorage.setItem('emailSecurityDeviceFingerprint', response.data.email_security_device_fingerprint);

        if (response.data.access_token) {
          localStorage.setItem('user', JSON.stringify(response.data));

          Vue.prototype.$api = axios.create({
            headers: {
              Authorization: `Bearer ${response.data.access_token}`
            }
          });

          this.$router.push('/').catch(() => {
          });
        }
      })
      .catch((error) => {
        this.$vs.loading.close();

        this.$vs.notify({
          time: 6000,
          title: 'Aviso',
          text: error.response.data.error || error.response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      });
    },

    emailSecuritySubmit(e) {
      this.emailSecurityCheck();

      e.preventDefault();
    },

    emailSecurityCancel() {
      this.email_security_code = '';
      this.email_security_active = false;
    },
  }
};
</script>

